import { render, staticRenderFns } from "./SponsorActivationEventInfo.view.vue?vue&type=template&id=61f3001e&scoped=true"
import script from "./SponsorActivationEventInfo.view.vue?vue&type=script&lang=js"
export * from "./SponsorActivationEventInfo.view.vue?vue&type=script&lang=js"
import style0 from "./SponsorActivationEventInfo.view.vue?vue&type=style&index=0&id=61f3001e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3001e",
  null
  
)

export default component.exports